import {ValueObject} from '@s-ui/domain'

import {ErrorFactoryFetcherValueObject} from './ErrorFactoryFetcherValueObject.js'

export class ErrorsFactoriesFetcherValueObject extends ValueObject {
  #errors

  constructor({errors}) {
    super()
    this.#errors = errors
  }

  static createFromErrorsConfig({errorsConfig}) {
    return new ErrorsFactoriesFetcherValueObject({
      errors: Object.entries(errorsConfig).map(([statusCode, {code, message}]) =>
        ErrorFactoryFetcherValueObject.createFromPrimitives({statusCode, code, message})
      )
    })
  }

  get errors() {
    return this.#errors.map(error => error.value)
  }

  getFactories() {
    return Object.fromEntries(this.#errors.map(error => error.getFactory()))
  }

  get value() {
    return {
      errors: this.errors
    }
  }
}
